import { useParentLoader } from '@core/router/loader';
import { layoutLoader } from '@layout/Layout';

export function useLayoutContext() {
  return useParentLoader<typeof layoutLoader>('layout');
}
